import ListView from "../../component/ListView";
import {Column} from "primereact/column";
import rest from "../../utils/EnvConfig";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";
import {UsuarioKeycloak} from "../../model/UsuarioKeycloak";

function UsuarioList() {

    const rolesTemplate = (usuario: UsuarioKeycloak) => {
        if (usuario.roles && usuario.roles.length > 0) {
            return usuario.roles.map((r: string) => r)
                .reduce((v, acc) => v + ", " + acc);
        }
        return "";
    }

    return (
        <>
            <h2>* Apenas para listagem dos usuários.</h2>
            <br />
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <ListView title={"Usuário"}
                          visibleNovo={false}
                          visiblePesquisar={false}
                          visibleExcluir={(entidade: UsuarioKeycloak) => false}
                          visibleEditar={(entidade: UsuarioKeycloak) => false}
                          id={`${rest.usuario}`}>
                    <Column field="nome" header="Nome" sortable />
                    <Column field="login" header="E-mail" sortable />
                    <Column field="cpf" header="CPF" sortable />
                    <Column field="enderecoCompleto" header="Endereço" sortable />
                    <Column field="roles" header="Tipo" sortable body={rolesTemplate} />
                </ListView>
            </RoleBasedAccess>
        </>
    );
}

export default UsuarioList;